export enum Category_e {
    MATERIALS = "build",
    CABLES = "power",
    BOARDS = "tab",
    LIGHTS = "lightbulb-outline"
}

/**
 * @description Get the enum category from string (via db)
 * @author Lucas Fridez <lfridez@artionet.com>
 * @export
 * @param {string} label franch string of the category
 * @returns {Category_e} the enum corresponding to the product category
 */
export function getEnumByLabel(label: string): Category_e {
    switch (label) {
        case "Outillage":
            return Category_e.MATERIALS;
        case "Câbles":
            return Category_e.CABLES;
        case "Luminaires":
            return Category_e.LIGHTS;
        case "Tableaux":
            return Category_e.BOARDS;
        default:
            return Category_e.MATERIALS;
    }
}



// WEBPACK FOOTER //
// ./src/app/framework/Category.ts